var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.473633,
    y: 0.0600586,
    width: 40.6718,
    height: 40.6718,
    rx: 20.3359,
    fill: "#32A7E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8215 20.4016L19.8227 20.7016C19.833 21.8917 19.9048 22.9534 20.0285 23.6263C20.0285 23.6384 20.1635 24.3058 20.2494 24.5279C20.3844 24.849 20.6284 25.1215 20.9344 25.2942C21.1793 25.4174 21.4363 25.4799 21.7053 25.4799C21.9167 25.4701 22.2654 25.3637 22.5143 25.2745L22.7211 25.1953C24.091 24.6511 26.7097 22.8731 27.7126 21.7857L27.7865 21.7097L28.1165 21.3536C28.3245 21.081 28.4345 20.7478 28.4345 20.3894C28.4345 20.0684 28.3365 19.7473 28.1406 19.4878C28.0819 19.4038 27.9874 19.2959 27.9033 19.2048L27.5821 18.8686C26.4768 17.7487 24.0836 16.1778 22.8431 15.6573C22.8431 15.6461 22.0722 15.3241 21.7053 15.312H21.6563C21.0934 15.312 20.5674 15.6331 20.2984 16.152C20.2249 16.2939 20.1544 16.5718 20.1008 16.8159L20.0045 17.2767C19.8945 18.0178 19.8215 19.1546 19.8215 20.4016ZM14.4564 19.1094C13.7529 19.1094 13.1826 19.6853 13.1826 20.3956C13.1826 21.1059 13.7529 21.6818 14.4564 21.6818L17.5908 21.4045C18.1427 21.4045 18.59 20.9537 18.59 20.3956C18.59 19.8384 18.1427 19.3866 17.5908 19.3866L14.4564 19.1094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.637bea4abe654ecc442bfc9fc93378aa.svg";
export { ForwardRef as ReactComponent };